<template>
	<div class="print">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">批量导出 </h2>
		
		<div class="search">
			<el-date-picker
			  v-model="searchDate"
			  type="daterange"
			  value-format="timestamp"
			  range-separator="至"
			  start-placeholder="开始日期"
			  end-placeholder="结束日期"
			  @change="searchDateChange">
			</el-date-picker>
			
			<el-button @click="batchPrint" class="batch-print">批量导出为PDF</el-button>
		</div>
		
		<el-table
			:data="user"
			stripe
			class="list"
			@selection-change="selectRows"
		>
			<el-table-column
				type="selection"
			>
			</el-table-column>
			<el-table-column
				prop="examdate"
				label="体检日期"
				class-name="examdate"
			>
			</el-table-column>
			<el-table-column
				prop="sex"
				label="客户性别"
				class-name="sex"
			>
			</el-table-column>
			<el-table-column
				prop="birth"
				label="出生日期"
				class-name="birth"
			>
			</el-table-column>
			<el-table-column
				label="套餐内容"
				class-name="package"
			>
				<template slot-scope="scope">
					{{scope.row.package == '2' ? (scope.row.custom.join('+').replace('base','基础体检套餐').replace('packageA','增值包-同族群PLM对比').replace('packageB','增值包-共病风险').replace('packageC','增值包-疾病风险远期预测').replace('packageD','增值包-健康促进方案')) : (scope.row.package == '1' ? '健康100' : scope.row.package == '3' ? '馨康母婴套餐' : '')}}
				</template>
			</el-table-column>
			
		</el-table>
		
		<!-- 分页 -->
		<el-pagination
			class="pagination qjc-texta-c"
			layout="prev, pager, next"
			hide-on-single-page
			:current-page.sync="pager.page"
			:page-count="pager.pagecount"
			:page-size="pager.pagesize"
			:total="pager.count"
			@current-change="pageChange">
		</el-pagination>
		
		<iframe id="iframe" class="qjc-wid-100 qjc-hei-100" :src="iframeUrl" frameborder="0"></iframe>
		
	</div>
</template>

<script>
	import { printBatchQuery } from '@/utils/axios'
	
	export default{
		name: 'reportBatch',
		data() {
			return {
				searchDate: '',//检索日期
				
				user: [],
				
				pager: {
					count: 0,
					page: 1,// 默认第一页
					pagecount: 0,
					pagesize: 10//默认一页10条数据
				},
				
				selectRowData: [],// 存储所选列表行数据
				
				iframeUrl: ''
			}
		},
		methods: {
			// 查询
			searchDateChange(daterange) {
				this.getList();
			},
			
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			
			// 获取列表数据
			getList() {
				printBatchQuery({
					act: 'export',
					begin: this.searchDate[0]/1000,
					end: this.searchDate[1]/1000,
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}).then(res => {
					if(res.code == 200){
						if(res.data.data.length == 0){
							this.$myAlert({
								title: res.msg
							});
						}else{
							this.user = res.data.data;
							
							//分页
							var pager = res.data.pager;
							for(var key in pager){
								pager[key] = parseInt(pager[key]);
							}
							this.pager = pager;
							
						}
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			
			// 批量打印
			batchPrint(){
				if(this.selectRowData.length > 0){
					var iframeDoc = document.getElementById('iframe');
					
					var url = this.$router.resolve({
						path: "/reportPrint/printTemplate",
						query: {
							id: this.selectRowData.map(a => a.id).join(','),
							type: 'download',
							begin: this.searchDate[0],
							end: this.searchDate[1]
						}
					}).href;
					
					//弹出导出提示框
					this.$myAlert({
						title: '请稍候...'
					});
					
					if(iframeDoc.contentWindow.getData && this.iframeUrl == url){
						iframeDoc.contentWindow.getData();
					}else{
						this.iframeUrl = url;
					}
					
				}else{
					this.$myAlert({
						title: '请选择打印行'
					});
				}
			},
			
			// 选中行
			selectRows(selection){
				this.selectRowData = selection;
			}
		}
	}
</script>

<style scoped>
	.search >>> .el-date-editor .el-range-separator{
		width: auto;
	}
	.el-date-editor >>> .el-range-input,
	.el-date-editor >>> .el-range-separator,
	.el-date-editor >>> .el-range__icon,
	.el-date-editor >>> .el-range-separator{
		font-size: 0.14rem;
	}
	.search >>> .el-input__inner,
	.el-date-editor >>> .el-range__icon,
	.el-date-editor >>> .el-range-separator{
		height: 0.4rem;
		line-height: 0.4rem;
	}
	.list >>> .el-checkbox__input.is-checked .el-checkbox__inner, 
	.list >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background-color: #6681FA;
		border-color: #6681FA;
	}
	.list >>> .el-table__body,
	.list >>> .el-table__footer, 
	.list >>> .el-table__header{
		table-layout: auto;
	}
	.list >>> table{
		width: 10.92rem;
	}
	.list.el-table--striped >>> .el-table__body tr.el-table__row--striped td,
	.list >>> thead th{
		background: #FAFBFC;
	}
	.list >>> .cell{
		padding-left: 0.24rem;
		padding-right: 0;
	}
	.list >>> thead th{
		/* display: inline-block; */
		color: #40444D;
		font-size: 0.14rem;
		font-weight: 500;
		text-align: left;
		border-bottom: none;
	}
	.list >>> td{
		color: #777F8F;
		font-size: 0.14rem;
		/* display: inline-block; */
		border-bottom: none;
	}
	.list >>> .package .cell{
		width: 5.53rem;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
		padding-right: 0.24rem;
	}
	.list >>> .examdate .cell{
		width: 1.95rem;
	}
	.list >>> .sex .cell{
		width: 1.38rem;
	}
	.list >>> .birth .cell{
		width: 1.87rem;
	}
	.pagination >>> button{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.pagination >>> button .el-icon{
		font-size: 0.14rem;
	}
	.pagination >>> li{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
		font-size: 0.14rem;
		font-weight: 400;
		color: #40444D;
		border: 0.01rem solid transparent;
		border-radius: 0.08rem;
		margin: 0 0.06rem;
		padding: 0;
		overflow: visible;
	}
	.pagination >>> li:hover,
	.pagination >>> li.active{
		color: #6681FA;
		font-weight: 600;
		border-color: #6681FA;
		border-left: 0.01rem solid #6681FA;
	}
</style>
<style lang="scss" scoped>
	.print{
		.el-button.qjc-fts-16{
			font-size: 0.15rem;
		}
		
		.search{
			margin-top: 0.32rem;
			
			.batch-print{
				font-size: 0.14rem;
				padding: 0.1rem;
				margin-left: 0.24rem;
			}
			.el-date-editor{
				width: 3.5rem;
				padding: 0.03rem 0.1rem;
			}
		}
		.list{
			margin-top: 0.4rem;
			
			&::before{
				display: none;
			}
			.el-button{
				font-size: 0.14rem;
				padding: 0.06rem 0.08rem;
				
				+.el-button{
					margin-left: 0.24rem;
				}
			}
		}
		.pagination{
			margin-top: 0.24rem;
			padding-right: 0.24rem;
			text-align: center;
		}
	}
	.el-select-dropdown__item.selected{
		color: #6681FA;
	}
	#iframe{
		height: 0;
	}
</style>
